"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntitiesItem = void 0;
const CompanyName_1 = require("./entities/CompanyName");
const RegistrationId_1 = require("./entities/RegistrationId");
exports.EntitiesItem = {
    company_name: CompanyName_1.CompanyName,
    registration_id: RegistrationId_1.RegistrationId,
};
